import SemeiaSessionService from "core/services/session";
export function initialize(application) {
  application.register("service:session", SemeiaSessionService);
}
export default {
  initialize
};